import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";

// const BASE_URL = "http://localhost:8000";
const BASE_URL = "https://idealpursuits.co.in/api";

const SeminarSection = () => {
    const [seminars, setSeminars] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const { isLogged, userData } = useAuth();
    const [selectedSeminar, setSelectedSeminar] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        // Fetch seminars from the server
        axios.get(`${BASE_URL}/seminar/getSeminarsForHome.php`)
            .then(response => response.data)
            .then(data => {
                if (data.success) {
                    setSeminars(data.seminars);
                }
            })
            .catch(error => console.error("Error fetching seminars:", error));
    }, []);

    const handleRegisterClick = (seminar) => {
        setSelectedSeminar(seminar);
        setShowModal(true);
    };

    const handleCheckboxChange = (e) => {
        setIsChecked(e.target.checked);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedSeminar(null);
        setIsChecked(false);
    };

    const handleContinue = (seminar) => {
        if (!isLogged) {
            navigate("/login");
        } else {
            handleRegisterClick(seminar)
        }
    };

    const handlePayment = async () => {
        if (!isChecked) {
            alert("Please accept the terms and conditions to proceed.");
            return;
        }

        try {
            setIsProcessing(true);

            const res = await initializeRazorpay();
            if (!res) {
                alert("Razorpay SDK failed to load. Are you online?");
                setIsProcessing(false);
                return;
            }

            // Create Razorpay order
            const orderResponse = await axios.post(`${BASE_URL}/create-seminar-order.php`, {
                amount: selectedSeminar.seminarPrice * 100,
                seminarPrice: selectedSeminar.seminarPrice,
                seminarId: selectedSeminar.seminarId,
                userId: userData.userId
            });

            const options = {
                key: "rzp_live_126ap0g6lfYF7b",
                amount: selectedSeminar.seminarPrice * 100,
                currency: "INR",
                name: "The Ideal Pursuits",
                description: `Registration for ${selectedSeminar.title}`,
                order_id: orderResponse.data.orderId,
                handler: async (response) => {
                    try {
                        // Verify payment
                        const verifyResponse = await axios.post(`${BASE_URL}/verify-seminar-payment.php`, {
                            razorpay_payment_id: response.razorpay_payment_id,
                            razorpay_order_id: response.razorpay_order_id,
                            razorpay_signature: response.razorpay_signature
                        });

                        if (verifyResponse.data.status === "success") {
                            await handlePaymentSuccess();
                        } else {
                            alert("Payment verification failed. Please try again.");
                        }
                    } catch (error) {
                        console.error("Payment verification error:", error);
                        alert("Payment verification failed.");
                    }
                },
                prefill: {
                    name: userData.name,
                    email: userData.email
                },
                theme: {
                    color: "#3399cc"
                },
                modal: {
                    ondismiss: () => {
                        setIsProcessing(false);
                    }
                }
            };

            const paymentObject = new window.Razorpay(options);
            paymentObject.open();
        } catch (error) {
            console.error("Payment initiation error:", error);
            alert("Failed to initiate payment. Please try again.");
        } finally {
            setIsProcessing(false);
        }
    };

    const handlePaymentSuccess = () => {
        handleCloseModal();
        setShowSuccessModal(true);
    }

    const formatTo12Hr = (time) => {
        const [hour, minute] = time.split(":");
        const formattedHour = hour % 12 || 12;
        const period = hour >= 12 ? "PM" : "AM";
        return `${formattedHour}:${minute} ${period}`;
    };

    const initializeRazorpay = () => {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    };

    return (
        <div className="seminar-section">
            {seminars.length > 0 && <h2 className="seminar-section-title">Career Ready Courses</h2>}
            <div className="seminar-list">
                {seminars.map((seminar) => (
                    <div className="seminar-card" key={seminar.seminarId}>
                        <div className="seminar-header">
                            <h3 className="seminar-title">{seminar.title}</h3>
                            {seminar.guestImageName ? (
                                <img
                                    src={`${BASE_URL}/images/guests/${seminar.guestImageName}`}
                                    alt={seminar.title}
                                    className="guest-image"
                                />
                            ) : (
                                <p className="no-image">No Image</p>
                            )}
                        </div>
                        <p className="seminar-description">{seminar.description}</p>
                        <div className="seminar-details">
                            <p><strong>Batch Start Date:</strong> {seminar.seminarDate}</p>
                            <p><strong>Time:</strong> {formatTo12Hr(seminar.seminarTime)}</p>
                            <p><strong>Price:</strong> ₹{seminar.seminarPrice}</p>
                        </div>
                        <button
                            className="register-button"
                            onClick={() => { handleContinue(seminar) }}
                        >
                            Register Now
                        </button>
                    </div>
                ))}
            </div>

            {showModal && selectedSeminar && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h3>Terms and Conditions</h3>
                        <p>Please accept the terms and conditions to register for the Career Ready Course.</p>
                        <ul>
                            <li>Attendees must attend the Career Ready Course on the given date and time.</li>
                            <li>Non-refundable registration fee applies.</li>
                        </ul>
                        <div className="terms-container">
                            <input
                                type="checkbox"
                                id="agreeTerms"
                                className="terms-checkbox"
                                checked={isChecked}
                                onChange={handleCheckboxChange}
                            />
                            <label htmlFor="agreeTerms" className="terms-label">
                                I agree to the{" "}
                                <a href="/#/terms-and-conditions" className="terms-link">
                                    Terms and Conditions
                                </a>{" "}
                                and{" "}
                                <a href="/#/privacy-policy" className="terms-link">
                                    Privacy Policy
                                </a>.
                            </label>
                        </div>
                        <button className="close-button" onClick={handleCloseModal}>
                            Close
                        </button>
                        <button
                            disabled={!isChecked || isProcessing}
                            className="proceed-to-pay"
                            onClick={handlePayment}
                        >
                            {isProcessing ? "Processing..." : "Proceed to Pay"}
                        </button>
                    </div>
                </div>
            )}

            {showSuccessModal && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h2>Payment Successful!</h2>
                        <p>
                            Your course is scheduled successfully.
                        </p>
                        <p>
                            You can find the course link and passcode in your <a href='/#/profile'>profile</a> section.
                        </p>
                        <button className="close-button" onClick={() => setShowSuccessModal(false)}>
                            Close
                        </button>
                        <button className="proceed-to-pay" onClick={() => navigate("/profile")}>
                            Go to Profile
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SeminarSection;
